import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'lambda', 'Lambda', [["path",{"d":"M6 20l6.5 -9"}],["path",{"d":"M19 20c-6 0 -6 -16 -12 -16"}]]);